jQuery(function($) {
    'use strict';

    $('.nav-search-open-button').click(function(e) {
        e.preventDefault();
        $('.header__content').addClass('header__content--search-visible');
        $('.header__content .nav-search__keywords').select().focus();
    });
    $('.nav-search-close-button').click(function(e) {
        e.preventDefault();
        $('.header__content').removeClass('header__content--search-visible');
    });

    // Since Yahoo search assistant can only be initialized onto one element, we need to check which element is being shown
    // Left nav form will be shown on small screens while header search will be shown on big screens
    // Check if left-nav-search-input is visible. Otherwise, assume header-search-input is visible
    var $yahooSearchInput = $('#left-nav-search-input:visible');

    if (!$yahooSearchInput.length) {
        $yahooSearchInput = $('#header-search-input');
    }


    var assistjsSrc = $yahooSearchInput.data('assistjs-src');
    var params = $yahooSearchInput.data('params');
    var input = $yahooSearchInput[0];
    if (input && input.id && params && assistjsSrc) {
      params.searchBoxId = input.id;
        var sdk = document.createElement('script');
        sdk.src = assistjsSrc;
        sdk.onload = function() {
            window.SearchAssist = new window.YAHOO.SAClass();

            window.SearchAssist.init(params);
        };

        document.body.appendChild(sdk);
    }
});